import { useMemo } from 'react';
import {
  useCreateProjectGroupCommentMutation,
  useGetProjectGroupCommentsQuery,
} from './comment.api.slice';
import CommentThreadList from '@/components/Comment/CommentThreadList';
import DeleteProjectGroupComment from './DeleteProjectGroupComment';

function ProjectGroupCommentList({
  projectGroupId,
}: {
  projectGroupId: string;
}) {
  const { data: allComments, isLoading } =
    useGetProjectGroupCommentsQuery(projectGroupId);
  const [createComment] = useCreateProjectGroupCommentMutation();

  // Filter out admin comments - only show user comments
  const comments = useMemo(() => {
    return (
      allComments?.filter(
        (comment) => comment.commentType !== 'admin_comment'
      ) || []
    );
  }, [allComments]);

  return (
    <CommentThreadList
      comments={comments}
      isLoading={isLoading}
      renderDelete={(comment) => (
        <DeleteProjectGroupComment
          commentId={comment._id}
          projectGroupId={projectGroupId}
          userId={comment.user?._id ?? ''}
        />
      )}
      onReply={async (parentCommentId, body) => {
        await createComment({
          projectGroupId,
          comment: body,
          parentCommentId,
        }).unwrap();
      }}
    />
  );
}

export default ProjectGroupCommentList;
